import { assertNotEmpty, type Optional } from '@festina-life/core'

import { useTemplateContext } from '../../context/templateContext'
import {
  type EnumeratedValueFrameFieldValue,
  isEnumeratedValueFrameFieldValue,
  isRangedValueFrameFieldValue,
  type RangedValueFrameFieldValue,
} from '../../types/templateModel'
import type { ExpressionTypeInformation } from '../fplusExpression/types'
import { TemplateFieldExpression } from '../templateFieldExpression/TemplateFieldExpression'

type Props = {
  frame: EnumeratedValueFrameFieldValue | RangedValueFrameFieldValue
  path: string
  enumTypeInformation?: Optional<ExpressionTypeInformation>
}

/**
 * View used for showing the frames found on a field value.
 */
export const FieldFramesValueDetails = ({
  frame,
  path,
  enumTypeInformation,
}: Props) => {
  const { templateVersion } = useTemplateContext()
  const shouldRenderEnumValueFrameExpression =
    isEnumeratedValueFrameFieldValue(frame) &&
    frame.entries?.expression?.fplusSource
  const shouldRenderRangedValueFrameExpression =
    isRangedValueFrameFieldValue(frame) && frame.range?.expression?.fplusSource

  assertNotEmpty(templateVersion)

  return (
    <div className="flex min-w-[1000px] flex-col gap-y-2">
      {shouldRenderEnumValueFrameExpression && (
        <TemplateFieldExpression
          expression={frame.entries?.expression}
          isExpanded
          path={`${path}.entries`}
          fallbackCode=""
          typeInformation={enumTypeInformation}
        />
      )}
      {shouldRenderRangedValueFrameExpression && (
        <TemplateFieldExpression
          expression={frame.range?.expression}
          isExpanded
          path={`${path}.range`}
          fallbackCode=""
        />
      )}
    </div>
  )
}
